module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAPCAYAAAA/I0V3AAABI0lEQVQ4T52SPUsDQRCGn8klRMROEBREBBu1087kDgsbm1Sa4pIqVf6AjfobLOysUqjxoxARtBOEO7VSe0HESsFCBMXGu5FLzJITJTm3meWdfWZnZ1/he2lttodsUEVZQGQSyAB3oMekrXUpnj21zkq00V1nnIAjhLFWIh71BaiI6x1GuuhObghN3YAM/A60qaHOSdk7Fd12ThDmOwKNlnjk7X1EtO5oV4B5POXkEKz+A9Ll5JDqSnIIqhF0Dsx0OYxXPoJh0S17gpRcA9nOYFgR1681HVHP5cGKfrv/D0eEoEvi+msNR5jxb9qDWLIH2DFQuYdwUUr+Vcx7BtzH4tM5AApNTW9Jk5ei99xeyNxkwI3pDH29lwijaDAlpYuHny1/AYVxYF+LJfwzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/flightDetail/stayPointImg.png
// module id = 8/tU
// module chunks = 2